var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcApproved({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 17.0959V15.8459H11.9833V14.5959H4.25V12.0959H16.75V13.5875H18V12.0959C18 11.4042 17.4417 10.8459 16.75 10.8459H13V8.9042C13.0167 8.0542 13.2667 7.22087 13.725 6.49587C14.675 4.9042 14.3083 2.8542 12.8667 1.6792C11.2583 0.370867 8.9 0.612534 7.59167 2.21253C7.2 2.69587 6.925 3.27087 6.81667 3.88753C6.64167 4.78753 6.81667 5.71253 7.28333 6.49587C7.73333 7.19587 7.98333 8.0042 8 8.8292V10.8292H4.25C3.55833 10.8292 3 11.3875 3 12.0792V14.5792C3 15.2709 3.55833 15.8292 4.25 15.8292V17.0792C4.25 17.7709 4.80833 18.3292 5.5 18.3292H11.9833V17.0792H5.5V17.0959ZM11.75 10.8459H9.25V9.59587H11.75V10.8459ZM8.04167 4.1292C8.29167 2.77087 9.6 1.8792 10.9583 2.1292C12.3167 2.3792 13.2083 3.68753 12.9583 5.04587C12.9083 5.3292 12.8 5.6042 12.65 5.86253C12.1833 6.62087 11.8917 7.47087 11.7917 8.3542H9.21667C9.11667 7.47087 8.825 6.62087 8.35833 5.87087C8.04167 5.34587 7.93333 4.7292 8.05 4.1292H8.04167Z",
    fill: "#007A55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6167 13.7209L15.5 17.8375L13.8833 16.2209L13 17.0959L15.5 19.5959L20.5 14.5959L19.6167 13.7209Z",
    fill: "#007A55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcApproved);
export default __webpack_public_path__ + "static/media/ic-approved.dbd13a9403697cb6c242329cbeeeccdb.svg";
export { ForwardRef as ReactComponent };